<script>
    import "firebase/firestore";
    import { getContext } from 'svelte';

    import LocationCardTitle from './LocationCardTitle.svelte';
    import LocationCardDescription from './LocationCardDescription.svelte';
    import LocationCardShowTitle from './LocationCardShowTitle.svelte';
    import LocationCardShowDescription from './LocationCardShowDescription.svelte';
    import Toggle from './Toggle.svelte';

    export let id = null;
    export let title = null;
    export let showTitle = null;
    export let description = null;
    export let showDescription = null;
    export let directLink = null;
    export let lat = null;
    export let lng = null;
    export let mapVisible = null;
    export let location = null;

    const db = getContext('firebase').getFirebase().firestore();

    let buildingName;
    if (location && location.building) {
        db.collection('buildings').doc(location.building).get().then((doc) => {
            if (doc.exists) {
                const data = doc.data();
                buildingName = data.title;
            }
        });
    }

    function updateTitle(event) {
        const { newTitle } = event.detail;
        db.collection('locations').doc(id).update({ title: newTitle });
    }

    function updateShowTitle(event) {
        const { newShowTitle } = event.detail;
        db.collection('locations').doc(id).update({showTitle: newShowTitle});
    }

    function updateDescription(event) {
        const { newDescription } = event.detail;
        db.collection('locations').doc(id).update({ description: newDescription });
    }

    function updateShowDescription(event) {
        const { newShowDescription } = event.detail;
        db.collection('locations').doc(id).update({showDescription: newShowDescription});
    }

    function updateMapVisible() {
        db.collection('locations').doc(id).update({mapVisible: !mapVisible});
    }

    const latLng = (lat && lng) ? `LAT ${lat.toFixed(2)}, LNG ${lng.toFixed(2)}` : '';
</script>

<div class="card">
    <img src={directLink} alt={title}>
    <div class="tray">
        <div class="geo">
            {#if buildingName}
                <span class="lat-lng">{buildingName}</span>
            {/if}
            {#if lat && lng}
                <span class="lat-lng">{latLng}</span>
                <span class="map-prompt">Show on Map</span>
                <Toggle toggled={mapVisible} clickFunc={updateMapVisible} />
            {/if}
        </div>
        <div>
            <a class="unstyled-a" href="/?p=embed&id={id}">
                <i class="far fa-code"></i>
            </a>
            <a class="unstyled-a" href="https://clarke.campuspano.io/view.html?l={id}" target="_blank">
                <i class="far fa-browser"></i>
            </a>
        </div>
    </div>
    <LocationCardTitle id={id} title={title} on:updateTitle={updateTitle} />
    <LocationCardShowTitle showTitle={showTitle} title={title} on:updateShowTitle={updateShowTitle} />
    <LocationCardDescription id={id} description={description} on:updateDescription={updateDescription} />
    <LocationCardShowDescription showDescription={showDescription} description={description} on:updateShowDescription={updateShowDescription} />
</div>

<style>
    .card {
        text-align: left;
        background-color: var(--white);
        color: var(--off-black);
        border-radius: 15px;
        margin: 20px 0px;
        padding: 20px;
        box-shadow: var(--box-shadow);
    }

    img {
        width: 100%;
        margin-bottom: 10px;
        border-radius: 5px;
        box-shadow: var(--box-shadow);
    }

    .tray {
        display: flex;
        flex-flow: row;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: flex-start;
    }

    .geo {
        display: flex;
        flex-flow: row;
        flex-wrap: nowrap;
        justify-content: flex-start;
        align-items: center;
    }

    .lat-lng {
        font-size: 14px;
        color: white;
        background-color: var(--light-black);
        margin-right: 10px;
        padding: 3px 10px 1px 10px;
        border-radius: 5px;
    }

    .map-prompt {
        margin-right: 10px;
    }

    i {
        cursor: pointer;
        padding: 10px;
        border: 1px solid var(--off-black);
        border-radius: 5px;
        -webkit-transition: all var(--fast);
        transition: all var(--fast);
    }

    i:hover {
        color: white;
        background-color: var(--primary);
        border: 1px solid var(--primary);
        box-shadow: var(--box-shadow);
    }
</style>
